import { render, staticRenderFns } from "./FloatingSupportButton.vue?vue&type=template&id=0ca72116&scoped=true"
import script from "./FloatingSupportButton.vue?vue&type=script&lang=js"
export * from "./FloatingSupportButton.vue?vue&type=script&lang=js"
import style0 from "./FloatingSupportButton.vue?vue&type=style&index=0&id=0ca72116&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca72116",
  null
  
)

export default component.exports